import React from 'react'
import { Box } from '@mui/system'
import { Typography, ProgressiveReading } from '@evocolabs/orkaui'
import theme from '@evocolabs/orkaui/lib/theme.cjs'
import { styled } from '@mui/material/styles'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { foreWord, content } from '@/src/components/Legal/LegalConten'
import Header from '@/src/components/HeaderV2'
import Footer from '@/src/components/Footer/Footer2'

const PREFIX = 'LegalTermsOfService'
const classes = {
  layout: `${PREFIX}-layout`,
  title: `${PREFIX}-title`
}

const Root = styled('div')(() => ({
  [`& .${classes.layout}`]: {
    padding: '0 max(108px, calc(100% - 808px)/2)',
    [theme.breakpoints.down('md')]: {
      padding: '0 88px'
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0 16px'
    },
    paddingTop: '48px',
    paddingBottom: '138px',
    '& a': {
      textDecoration: 'underline',
      color: theme.palette.grey[800],
      fontWeight: '500',
      '&:hover': {
        textDecoration: 'underline',
        color: theme.palette.grey[800],
        fontWeight: '500'
      },

      '&:active': {
        textDecoration: 'underline',
        color: theme.palette.grey[800],
        fontWeight: '500'
      },

      '&:visited': {
        textDecoration: 'underline',
        color: theme.palette.grey[800],
        fontWeight: '500'
      },

      '&:link': {
        textDecoration: 'underline',
        color: theme.palette.grey[800],
        fontWeight: '500'
      }
    }
  },
  [`& .${classes.title}`]: {
    padding: '40px 0',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.grey[100]
  }
}))

const LegalTermsOfService = () => {
  return (
    <Root>
      <Header isWhiteBg />
      <Box width="100%">
        <div className={classes.title}>
          <Typography variant="h1" textAlign="center">
            Terms of Service
          </Typography>
          <Typography variant="subh1" textAlign="center">
            Last Updated: November 14, 2022
          </Typography>
        </div>
        <Box className={classes.layout}>
          <div>
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {foreWord}
            </ReactMarkdown>
          </div>
          <div>
            <ProgressiveReading content={content}></ProgressiveReading>
          </div>
        </Box>
      </Box>
      <Footer />
    </Root>
  )
}

export default LegalTermsOfService
